import * as actionTypes from "./TasksTypes";

const INITIAL_STATE = {
  tasksList: [],
  taskStatusList: [],
  employeeList: [],
  superUser: null,
  task: [],
  attachmentData: [],
  taskListById: [],
  taskStatusCount: [],
  commentsList: [],
};

const TasksReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SETTASKSLIST:
      return {
        ...state,
        tasksList: action.payload,
      };
    case actionTypes.SETTASKSTATUSLIST:
      return {
        ...state,
        taskStatusList: action.payload,
      };
    case actionTypes.SETEMPLOYEELIST:
      return {
        ...state,
        employeeList: action.payload.list,
      };
    case actionTypes.SETSUPERUSER:
      return {
        ...state,
        superUser: action.payload.data,
      };
    case actionTypes.SETTASK:
      return {
        ...state,
        task: action.payload,
      };
    case actionTypes.SETATTACHMENTDATA:
      return {
        ...state,
        attachmentData: action.payload,
      };
    case actionTypes.SETTASKLISTBYID:
      return {
        ...state,
        taskListById: action.payload,
      };
    case actionTypes.SETTASKCOUNT:
      return {
        ...state,
        taskStatusCount: action.payload,
      };
    case actionTypes.SETCOMMENTSLISTDATA:
      return {
        ...state,
        commentsList: action.payload,
      };
    default:
      return state;
  }
};

export default TasksReducer;
